import { create } from "zustand";

/**
 * Whether the login "What's new" dialog has decided what to show and is
 * open, for other login-time dialogs (C-16 S6's daily To-Dos gate) to wait
 * their turn instead of opening on top of it.
 */
interface WhatsNewOpenStateI {
  hasDecided: boolean;
  isOpen: boolean;
  set: (state: { hasDecided: boolean; isOpen: boolean }) => void;
}

export const useWhatsNewOpenState = create<WhatsNewOpenStateI>((set) => ({
  hasDecided: false,
  isOpen: false,
  set: (state) => set(state),
}));
